// A lista de destinos da app — uma só, partilhada.
//
// A barra de cima (desktop) e o carrossel de baixo (telemóvel) leem daqui, por
// isso um destino novo aparece nos dois sítios ao mesmo tempo. Era o que já
// acontecia entre a barra e o antigo menu hamburger; só mudou quem lê.

import type { ComponentType } from "react";
import {
  IconeCalendario,
  IconeCasa,
  IconeComando,
  IconeCoracao,
  IconeFoto,
  IconeLivro,
  IconeMarco,
  IconePino,
  IconeSino,
} from "@/components/ui/icones";

export type Ligacao = {
  href: string;
  etiqueta: string;
  icone: ComponentType<{ className?: string }>;
};

export const LINKS: Ligacao[] = [
  { href: "/", etiqueta: "Início", icone: IconeCasa },
  { href: "/timeline", etiqueta: "O trilho", icone: IconeMarco },
  { href: "/album", etiqueta: "Álbum", icone: IconeFoto },
  { href: "/mapa", etiqueta: "Mapa", icone: IconePino },
  { href: "/calendario", etiqueta: "Calendário", icone: IconeCalendario },
  { href: "/conto", etiqueta: "Conto", icone: IconeLivro },
  { href: "/para-sempre", etiqueta: "Mensagens", icone: IconeCoracao },
  { href: "/jogos", etiqueta: "Jogos", icone: IconeComando },
  // IDEA-044. Entrando aqui, aparece de uma vez na barra de cima e no carrossel
  // de baixo — que é exactamente o que este ficheiro existe para fazer.
  // "Avisos" e não "Notificações": a etiqueta vive num lugar de 76px debaixo de
  // um ícone, e a palavra inteira não lá cabe sem ser cortada a meio.
  { href: "/notificacoes", etiqueta: "Avisos", icone: IconeSino },
];

export function eAtivo(pathname: string, href: string): boolean {
  return href === "/" ? pathname === "/" : pathname.startsWith(href);
}

/** Índice do destino a que a página pertence — 0 (Início) se nenhum servir. */
export function indiceAtivo(pathname: string): number {
  const i = LINKS.findIndex((l) => eAtivo(pathname, l.href));
  return i === -1 ? 0 : i;
}
